'use client';
import React from 'react';

import Tabs, { TabPane } from 'rc-tabs';
type Props = {
  activeKey?: any;
  closable?: boolean;
  tab?: string;
  icon?: React.JSX.Element;
  key?: any;
  defaultActiveKey?: any;
  editable?: any;
  onChange?: (any) => void;
  children?: React.ReactNode;
  onTabClick?: (key: string, e: React.KeyboardEvent<Element>) => void;
};
export const TabsComponent = ({
  defaultActiveKey,
  activeKey,
  editable,
  onChange,
  children,
  onTabClick,
}: Props) => {
  return (
    <Tabs
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      editable={editable}
      onChange={onChange}
      onTabClick={onTabClick}
    >
      {children}
    </Tabs>
  );
};
TabsComponent.TabPane = TabPane;
export default TabsComponent;
